function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTransition, animated } from "@react-spring/web";
import { debounce, noop } from "lodash-es";
import { onEnter, useIcon } from "../../helpers";
import { positions, arrowPositions, types, getTransition } from "./options";
import { CheckCircle, Warning, Info, Cancel, Close } from "../../icons";
function useTransitionWrapper(props, className, renderAlertCard) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var transitions = useTransition([show], _objectSpread(_objectSpread({}, getTransition(props.position)), {}, {
    config: {
      tension: 210,
      friction: 20
    }
  }));
  var closeTimer = null;
  function clearCloseTimer() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }
  var confirmClose = debounce(function () {
    clearCloseTimer();
    props.onClose();
  }, 500);
  function close(e) {
    if (e) {
      e.stopPropagation();
    }
    setShow(false);
    confirmClose();
  }
  function startCloseTimer() {
    if (props.timeout) {
      closeTimer = setTimeout(function () {
        close();
      }, props.timeout);
    }
  }
  function restartCloseTimer() {
    clearCloseTimer();
    startCloseTimer();
  }
  useEffect(function () {
    startCloseTimer();
    return function () {
      clearCloseTimer();
    };
  }, []);
  useEffect(function () {
    restartCloseTimer();
  }, [props.timeout]);
  return transitions(function (style, item, _, key) {
    return item && /*#__PURE__*/React.createElement(animated.div, {
      key: key,
      style: style,
      className: className
    }, renderAlertCard(close));
  });
}
var AlertCard = function AlertCard(_ref) {
  var _ref$prefixClassName = _ref.prefixClassName,
    prefixClassName = _ref$prefixClassName === void 0 ? "tui-alert" : _ref$prefixClassName,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? 5000 : _ref$timeout,
    _ref$closable = _ref.closable,
    closable = _ref$closable === void 0 ? true : _ref$closable,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "" : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "" : _ref$position,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? noop : _ref$onClose,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$hasTransition = _ref.hasTransition,
    hasTransition = _ref$hasTransition === void 0 ? false : _ref$hasTransition,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? undefined : _ref$icon,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? false : _ref$arrow,
    _ref$arrowPosition = _ref.arrowPosition,
    arrowPosition = _ref$arrowPosition === void 0 ? "top-right" : _ref$arrowPosition;
  var arrowClass = arrow ? "arrow arrow-".concat(arrowPosition) : "";
  var fullClassName = "".concat(prefixClassName, "-card ").concat(type, " ").concat(position, " ").concat(size, " ").concat(className, " ").concat(arrowClass);
  var iconElement = useIcon(icon);
  var innerIcon = null;
  switch (type) {
    case types.INFO:
    case types.DEFAULT:
      innerIcon = /*#__PURE__*/React.createElement(Info, null);
      break;
    case types.WARNING:
      innerIcon = /*#__PURE__*/React.createElement(Warning, null);
      break;
    case types.ERROR:
      innerIcon = /*#__PURE__*/React.createElement(Cancel, null);
      break;
    case types.SUCCESS:
      innerIcon = /*#__PURE__*/React.createElement(CheckCircle, null);
      break;
  }
  function renderAlertCard(close) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, icon ? iconElement : innerIcon, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, children), closable && /*#__PURE__*/React.createElement("span", {
      className: "close-alert",
      tabIndex: "0",
      role: "button",
      onClick: close,
      onKeyPress: onEnter(close)
    }, /*#__PURE__*/React.createElement(Close, {
      tabIndex: "-1"
    })), timeout && closable && /*#__PURE__*/React.createElement("span", {
      className: "timeout-bar",
      style: {
        animationDuration: "".concat(timeout, "ms")
      }
    }));
  }
  return hasTransition ?
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useTransitionWrapper({
    position: position,
    onClose: onClose,
    timeout: timeout
  }, fullClassName, renderAlertCard) : /*#__PURE__*/React.createElement("div", {
    className: fullClassName
  }, renderAlertCard(onClose));
};
AlertCard.propTypes = {
  prefixClassName: PropTypes.string,
  timeout: PropTypes.number,
  onClose: PropTypes.func,
  closable: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(types)),
  size: PropTypes.string,
  position: PropTypes.oneOf(Object.values(positions)),
  children: PropTypes.any,
  hasTransition: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.func,
  arrow: PropTypes.bool,
  arrowPosition: PropTypes.oneOf(Object.values(arrowPositions))
};
export default AlertCard;
//# sourceMappingURL=AlertCard.js.map